import { Flex } from '@aws-amplify/ui-react';
import React from 'react';
import ReactModal from 'react-modal';
import { Link } from 'react-router-dom';
import General from '../utils/GeneralUtils';
import './ExportStatusModal.scss';

interface ExportStatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  exportId: string;
}

const ExportStatusModal: React.FC<ExportStatusModalProps> = ({ isOpen, onClose, exportId }) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={General.getModalDefaults({ padding: '40px 30px', width: '540px', backgroundColor: '#000' })}
      closeTimeoutMS={200}
      parentSelector={General.getModalRoot}
    >
      <Flex direction='column' alignItems='center' justifyContent='center' className="export-status-modal">
        <div className="export-status-modal__image">
          <img src="/loading-cubes.gif" width={64} height={64} alt="Processing export" />
        </div>
        <div className="export-status-modal__title">
          We're working on your export
        </div>
        <div className="export-status-modal__description">
          Check the status of your export on the <i>Exports</i> page. Most exports take less than 3 minutes.
        </div>
        <Link
          to={`/exports`}
          className="export-status-modal__link"
        >
          Check status
        </Link>
      </Flex>
    </ReactModal>
  );
};

export default ExportStatusModal;